import React from "react";
import _ from "underscore";
import PropTypes from "prop-types";

/*
 * Render a reusable select-option component
 * @param dropdownValues an object, for example { S: "Size S", 2L: "Size 2L - Unavailable", ... }
 * @param onChange the onChange function
 * @placeholderOption: the text that goes in the placeholder option
 * @selectorName: the name attribute of the select-option element
 */

class AtomDropDownSelectOption extends React.Component {
  static propTypes = {
    dropdownValues: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholderOption: PropTypes.string.isRequired,
    selectorName: PropTypes.string.isRequired,
    selectedOption: PropTypes.string,
    disableRule: PropTypes.func, // Allows for the passing in of rule for disabling an option
    optionalClassName: PropTypes.string,
  };

  static defaultProps = {
    optionalClassName: "",
  };

  getSelectedOption = () => {
    return this.props.selectedOption || "";
  };

  handleChange = e => {
    var value = e.target.value;

    this.props.onChange(value);
  };

  render() {
    const { disableRule, optionalClassName } = this.props;
    return (
      <select
        readOnly
        onChange={this.handleChange}
        value={this.getSelectedOption()}
        name={this.props.selectorName}
        className={`drop-down-select-option ${optionalClassName}`}>
        <option value="">{this.props.placeholderOption}</option>

        {_.map(this.props.dropdownValues, function (val, key) {
          const disabled = _.isFunction(disableRule) && disableRule(val);
          return (
            <option disabled={disabled} key={key} value={key}>
              {val}
            </option>
          );
        })}
      </select>
    );
  }
}

export default AtomDropDownSelectOption;
